module.exports = __webpack_public_path__ + "img/defaultShow.eacc53e.png";